import { autoinject, transient } from "aurelia-dependency-injection";

@autoinject()
@transient()
export class PdfDownloadLink {
    attached() {

        const queryStringBreaker = '?originalUrl=';
        const indexOfQueryString = location.href.indexOf(queryStringBreaker);
        const queryString = location.href.substring(indexOfQueryString).replace(queryStringBreaker, '');
        const urlToDownload = decodeURIComponent(queryString);        
        location.href = indexOfQueryString != -1 ? urlToDownload : "/";
    }
}